const TRVID_MAP = {
  "56096": "nordvpn",
  "56097": "surfshark",
  "38875": "purevpn",
  "56098": "veepn",
  "56099": "adguard-vpn",
};

export function vpnFromHref(href = "") {
  const m = /trvid=(\d+)/.exec(href);
  return (m && TRVID_MAP[m[1]]) || "unknown";
}

const ATTR_KEY = "vpnr_attribution";
const ATTR_PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid"];

function captureAttribution() {
  try {
    const qs = new URLSearchParams(window.location.search);
    const found = {};
    ATTR_PARAMS.forEach((k) => {
      const v = qs.get(k);
      if (v) found[k] = v.slice(0, 200);
    });
    if (Object.keys(found).length) {
      sessionStorage.setItem(ATTR_KEY, JSON.stringify(found));
    }
  } catch (e) {}
}
captureAttribution();

export function getAttribution() {
  try {
    return JSON.parse(sessionStorage.getItem(ATTR_KEY)) || {};
  } catch (e) {
    return {};
  }
}

let lastTrackedPath = null;

export function trackPageView(page) {
  if (page === lastTrackedPath) return;
  lastTrackedPath = page;
  const attr = getAttribution();
  const paid = !!(attr.gclid || ["cpc", "ppc", "paid", "paidsearch"].includes((attr.utm_medium || "").toLowerCase()));
  try {
    const payload = JSON.stringify({
      page,
      source: paid ? "paid" : "organic",
      utm_term: attr.utm_term || "",
      utm_campaign: attr.utm_campaign || "",
    });
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/track/pageview`;
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([payload], { type: "application/json" }));
    } else {
      fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: payload, keepalive: true });
    }
  } catch (e) {}
}

export function trackClick(href, placement = "") {
  const vpn = vpnFromHref(href);
  const ctaId = placement || "unlabeled";
  const page = window.location.pathname;
  const attr = getAttribution();
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", "cta_click", {
        cta_id: ctaId,
        vpn,
        page_path: page,
        ad_keyword: attr.utm_term || "(none)",
        campaign: attr.utm_campaign || "(none)",
        traffic_source: attr.utm_source || (attr.gclid ? "google_ads" : "(direct/organic)"),
      });
    }
  } catch (e) {}
  try {
    const payload = JSON.stringify({
      vpn,
      placement: ctaId,
      page,
      utm_source: attr.utm_source || "",
      utm_medium: attr.utm_medium || "",
      utm_campaign: attr.utm_campaign || "",
      utm_term: attr.utm_term || "",
      gclid: attr.gclid || "",
    });
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/track/click`;
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([payload], { type: "application/json" }));
    } else {
      fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: payload, keepalive: true });
    }
  } catch (e) {
    // tracking must never break navigation
  }
}
